import type { PropsWithChildren } from "react";

export const PageWrapper = ({ children }: PropsWithChildren) => (
  <div className="flex min-h-screen flex-col bg-background-primary py-12 dark:bg-background-primary-dark">
    {children}
  </div>
);
